import {Frontend} from "./frontend";

(function () {
    XonBoard.PressureSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function (has_offset, shown_cols, fresh) {
                if (fresh) {
                    this.selectors.sensor_reads_table = $('#sensor-reads-table');
                    this.selectors.count_label = $('#count-label');
                }

                function showColumn(name) {
                    return shown_cols.includes(name);
                }

                let self = this;

                let columns = [
                    {data: 'received_date', name: 'sensor_reads.received_date', createdCell: self.renderCell,},
                    showColumn('battery') ? {data: 'battery', name: 'sensor_reads.battery', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    {data: 'status', name: 'sensor_reads.status', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'diesel_deep_cm', name: 'sensor_reads.diesel_deep_cm', createdCell: self.renderCell, sortable: false, searchable: false},
                    has_offset ? {data: 'diesel_deep_cm_with_offset', name: 'sensor_reads.diesel_deep_cm_with_offset', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    {data: 'fuel_level', name: 'sensor_reads.fuel_level', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'consumption', name: 'sensor_reads.consumption', createdCell: self.renderCell, sortable: false, searchable: false},
                    {data: 'to_fill', name: 'sensor_reads.to_fill', createdCell: self.renderCell, sortable: false, searchable: false},
                    showColumn('pressure_kpa') ? {data: 'pressure_kpa', name: 'sensor_reads.pressure_kpa', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('in_1_pin_level') ? {data: 'in_1_pin_level', name: 'sensor_reads.in_1_pin_level', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('in_2_pin_level') ? {data: 'in_2_pin_level', name: 'sensor_reads.in_2_pin_level', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('idc_intput_m_a') ? {data: 'idc_intput_m_a', name: 'sensor_reads.idc_intput_m_a', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('vdc_intput_v') ? {data: 'vdc_intput_v', name: 'sensor_reads.vdc_intput_v', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('exti_pin_level') ? {data: 'exti_pin_level', name: 'sensor_reads.exti_pin_level', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('exti_status') ? {data: 'exti_status', name: 'sensor_reads.exti_status', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    showColumn('probe_mod') ? {data: 'probe_mod', name: 'sensor_reads.probe_mod', createdCell: self.renderCell, sortable: false, searchable: false} : null,
                    {data: 'actions', name: 'actions', searchable: false, sortable: false, createdCell: self.renderCell,}
                ].filter((item) => item);


                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: columns,
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if(cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
